import { Injectable } from '@angular/core';
import { UnitsV2 } from '@schenck/rotec-components';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import {
  RotorTypeDrive,
  RotorTypeValue,
  RotorTypeValueV2,
} from 'src/utils/interfaces/rotor-type.interfaces';
import { mapToRotorTypeValue, mapToRotorTypeValueV2 } from './adapter.mappers';
import { PositioningMode } from 'src/utils/enums/rotor-type.enum';

export class RotorTypeDriveModel implements RotorTypeDrive {
  constructor(
    public readonly directionOfRotation: RotorTypeValueV2,
    public readonly balancingSpeed: RotorTypeValue,
    public readonly selectedPositioningAid: RotorTypeValueV2<PositioningMode>,
    public readonly positioningTolerance: RotorTypeValueV2
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class DriveAdapter implements Adapter<RotorTypeFormsData, RotorTypeDrive> {
  /**
   * Creates the adapted form data for drive field
   *
   * @param formData: RotorTypeFormsData
   * @param units: UnitsV2[]
   * @returns RotorTypeDrive
   */
  adapt(formData: RotorTypeFormsData, units: UnitsV2[]): RotorTypeDrive {
    return new RotorTypeDriveModel(
      {
        name: 'rotor direction',
        value: formData.rotorTypeSettingsStep.rotateDirection,
        isEdited: true,
      },
      mapToRotorTypeValue(formData.rotorTypeSettingsStep.balancingSpeed, units),
      mapToRotorTypeValueV2<PositioningMode>({
        name: 'selectedPositioningAid',
        value: formData.measurementSettingsStep.positioningMode,
      }),
      mapToRotorTypeValueV2(formData.measurementSettingsStep.positioningAngle)
    );
  }
}
